<!-- components/ThemeToggle.vue -->
<template>
    <v-btn
      icon
      variant="text"
      size="small"
      @click="toggleTheme"
      :title="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
    >
      <v-icon v-if="isDark" size="24">mdi-weather-sunny</v-icon>
      <v-icon v-else size="24">mdi-weather-night</v-icon>
    </v-btn>
</template>

<script setup>
import { useThemeManager } from '@/composables/useTheme'

const { isDark, toggleTheme } = useThemeManager()
</script>